import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import LoadingPage from '../LoadingPage';
import ApiService from '../../services/ApiService';
import ModalTable from '../modal/ModalTable';

const headers = [
  {
    text: 'Purchase Order',
    name: 'PurchaseOrder',
    flex: 1,
  },
  {
    text: 'Date',
    width: 125,
  },
  {
    text: 'Source',
    width: 100,
  },
  {
    text: 'Status',
    width: 75,
  },
  {
    text: 'Reference',
    width: 125,
  },
  {
    text: 'Memo',
    hide: true,
  },
  {
    text: 'Invoice',
    hide: true,
  },
  {
    text: 'Account',
    hide: true,
  },
  {
    text: 'Amount',
    type: 'currencyColumn',
    className: 'right',
    aggregate: 'sum',
    width: 125,
  },
  {
    text: '$',
    name: 'Currency',
    width: 35,
    className: 'center',
    type: 'currencyCountryColumn',
  },
  {
    text: 'Adjusted Amount',
    type: 'currencyColumn',
    name: 'Adjusted',
    minWidth: 120,
    className: 'right',
    aggregate: 'sum',
  },
];

const repairHeaders = [
  {
    text: 'Repair Order',
    name: 'RepairOrderNumber',
    flex: 1,
  },
  {
    text: 'Date',
  },
  {
    text: 'Mileage',
  },
  {
    text: 'Status',
    width: 75,
  },
  {
    text: 'Amount',
    name: 'EstimateAmount',
    type: 'currencyColumn',
    className: 'right',
    aggregate: 'sum',
  },
];

const QuoteCostToDate = ({ quoteId, callback }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [repairData, setRepairData] = useState({});
  const [hasAdjustments, setHasAdjustments] = useState(false);
  const [baseCurrency, setBaseCurrency] = useState('USD');

  const fetchBreakdown = () => {
    ApiService.put(`crm/quote/${quoteId}/update-cost`)
      .then(response => {
        const closed = _.get(response, 'data.breakdown.ClosedPurchaseOrders', []);
        const open = _.get(response, 'data.breakdown.OpenPurchaseOrders', []);
        const history = _.get(response, 'data.breakdown.RepairOrderHistory', []);
        setHasAdjustments(_.get(response, 'data.breakdown.hasAdjustments', false));
        setBaseCurrency(_.get(response, 'data.breakdown.baseCurrency', 'USD'));

        const gridData = [];
        const values = [];

        const repairGridData = [];
        const repairValues = [];

        closed.forEach(o => {
          o.Status = 'Closed';
          gridData.push(headers.map(h => o[h.name || h.text]));
          values.push(o.Amount);
        });

        open.forEach(o => {
          o.Status = 'Open';
          gridData.push(headers.map(h => o[h.name || h.text]));
          values.push(o.Amount);
        });

        history.forEach(o => {
          if (o.Status === 'Open') {
            repairGridData.push(repairHeaders.map(h => o[h.name || h.text]));
            repairValues.push(o.EstimateAmount);
          }
        });

        setData(gridData);
        setRepairData(repairGridData);

        if (callback) {
          callback(response);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchBreakdown();
  }, []);

  if (!hasAdjustments) {
    headers[9].hide = true;
    headers[10].hide = true;
  } else {
    headers[9].hide = false;
    headers[9].defaultValue = baseCurrency;
    headers[10].hide = false;
  }

  return (
    <div className="quote-costtodate">
      {loading && !data.ClosedPurchaseOrders ? (
        <LoadingPage />
      ) : (
        <div>
          <h6>Purchase Orders</h6>
          <hr />
          <ModalTable controlId="pos" headers={headers} data={data} hideToolbar={true} style={{ height: '200px' }} />

          <h6 className="mt-4">Repair Orders</h6>
          <hr />
          <ModalTable controlId="repair" headers={repairHeaders} data={repairData} hideToolbar={true} style={{ height: '200px' }} />
        </div>
      )}
    </div>
  );
};

export default QuoteCostToDate;
